import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const Error = (props: Props): ReactElement => {
  const { width, height, fill } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="6" cy="6" r="6" fill={fill} />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M6.562 7.014l.101-4.319C6.672 2.32 6.375 2.01 6 2h-.016c-.376 0-.68.305-.68.68v.015L5.4 7.014c.007.315.265.568.581.568.316 0 .574-.253.581-.568zM6 9.989c.24 0 .424-.067.554-.201.13-.134.196-.3.196-.5 0-.206-.067-.378-.201-.514-.134-.135-.317-.203-.549-.203-.232 0-.415.068-.549.203-.134.136-.201.308-.201.514 0 .2.065.366.196.5.13.134.315.201.554.201z"
        />
      </g>
    </svg>
  );
};

Error.defaultProps = {
  width: '100%',
  height: '100%',
  fill: '#FFF',
};

export default Error;
